
import React from 'react';

const SyllabusSection: React.FC = () => {
  const modules = [
    { id: 1, title: 'Introducción a la clínica', icon: 'ri-hospital-line' },
    { id: 2, title: 'Anatomía', icon: 'ri-body-scan-line' },
    { id: 3, title: 'Nutrición', icon: 'ri-restaurant-line' },
    { id: 4, title: 'Patologías Neurológicas', icon: 'ri-brain-line' },
    { id: 5, title: 'Cardio', icon: 'ri-heart-pulse-line' },
    { id: 6, title: 'Respiratorio', icon: 'ri-lungs-line' },
    { id: 7, title: 'Digestivo', icon: 'ri-capsule-line' },
    { id: 8, title: 'Urinario', icon: 'ri-drop-line' },
    { id: 9, title: 'Reproductor', icon: 'ri-parent-line' },
    { id: 10, title: 'Oncología', icon: 'ri-microscope-line' },
    { id: 11, title: 'Dermatología', icon: 'ri-hand-sanitizer-line' },
    { id: 12, title: 'Oftalmología', icon: 'ri-eye-line' },
    { id: 13, title: 'Otología y Etología', icon: 'ri-ear-line' },
    { id: 14, title: 'Traumatología', icon: 'ri-bone-line' },
    { id: 15, title: 'Animales exóticos', icon: 'ri-bird-line' },
    { id: 16, title: 'Eutanasia', icon: 'ri-heart-3-line' },
    { id: 17, title: 'Diagnósticos', icon: 'ri-stethoscope-line' },
    { id: 18, title: 'Exploración', icon: 'ri-search-eye-line' },
    { id: 19, title: 'Manejo', icon: 'ri-hand-heart-line' },
    { id: 20, title: 'Laboratorio', icon: 'ri-flask-line' },
    { id: 21, title: 'Urgencias', icon: 'ri-alarm-warning-line' },
    { id: 22, title: 'Quirófano', icon: 'ri-scissors-cut-line' },
    { id: 23, title: 'Hospitalización', icon: 'ri-hospital-bed-line' }
  ];

  // Dividir en 3 columnas
  const column1 = modules.slice(0, 8);
  const column2 = modules.slice(8, 16);
  const column3 = modules.slice(16, 23);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Programa Completo de Formación
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            23 módulos especializados diseñados por veterinarios profesionales
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {/* Columna 1 */}
          <div className="space-y-4">
            {column1.map((module) => (
              <div 
                key={module.id}
                className="flex items-center gap-4 bg-white border-2 border-gray-100 rounded-xl p-4 hover:border-teal-200 hover:bg-teal-50 transition-all duration-300 group cursor-pointer"
              >
                <div className="flex-shrink-0 w-10 h-10 bg-teal-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
                  {module.id}
                </div>
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                  <i className={`${module.icon} text-2xl text-teal-500 group-hover:text-teal-600 transition-colors duration-300`}></i>
                </div>
                <h3 className="font-semibold text-gray-900 text-sm group-hover:text-teal-700 transition-colors duration-300 whitespace-nowrap">
                  {module.title}
                </h3>
              </div>
            ))}
          </div>

          {/* Columna 2 */}
          <div className="space-y-4">
            {column2.map((module) => (
              <div 
                key={module.id}
                className="flex items-center gap-4 bg-white border-2 border-gray-100 rounded-xl p-4 hover:border-teal-200 hover:bg-teal-50 transition-all duration-300 group cursor-pointer"
              >
                <div className="flex-shrink-0 w-10 h-10 bg-teal-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
                  {module.id}
                </div>
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                  <i className={`${module.icon} text-2xl text-teal-500 group-hover:text-teal-600 transition-colors duration-300`}></i>
                </div>
                <h3 className="font-semibold text-gray-900 text-sm group-hover:text-teal-700 transition-colors duration-300 whitespace-nowrap">
                  {module.title}
                </h3>
              </div>
            ))}
          </div>

          {/* Columna 3 */}
          <div className="space-y-4">
            {column3.map((module) => (
              <div 
                key={module.id}
                className="flex items-center gap-4 bg-white border-2 border-gray-100 rounded-xl p-4 hover:border-teal-200 hover:bg-teal-50 transition-all duration-300 group cursor-pointer"
              >
                <div className="flex-shrink-0 w-10 h-10 bg-teal-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
                  {module.id}
                </div>
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                  <i className={`${module.icon} text-2xl text-teal-500 group-hover:text-teal-600 transition-colors duration-300`}></i>
                </div>
                <h3 className="font-semibold text-gray-900 text-sm group-hover:text-teal-700 transition-colors duration-300 whitespace-nowrap">
                  {module.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
        
        {/* Información adicional */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center px-6 py-3 bg-teal-100 text-teal-700 rounded-full">
            <i className="ri-time-line mr-2"></i>
            <span className="font-medium">Duración flexible - Estudia a tu propio ritmo</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SyllabusSection;
